import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import { match } from '../../../utils/patternMatchUtil';
import InfoForm from '../../components/InfoForm';
import { Form, Input } from '../../../components/Form';
import Modal from '../../../components/Modal';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from '../../../components/Dialog';
import _History from './History';
import _Access from './Access';
import styles from './DocumentInspectorView.m.sass';
import { isMobile } from '../../../utils/mobileDetect';
var DocumentInspectorView = function DocumentInspectorView(_ref) {
  var view = _ref.view,
    showTags = _ref.showTags;
  var View = match(view.viewTab, {
    History: function History() {
      return _History;
    },
    Info: function Info() {
      return _Info;
    },
    Access: function Access() {
      return _Access;
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root)
  }, /*#__PURE__*/React.createElement(View, {
    view: view,
    showTags: showTags
  }), /*#__PURE__*/React.createElement(ConfirmDialog, {
    position: "top",
    title: "Remove this access?",
    yes: "Remove Access",
    danger: true,
    state: view.confirmAccessDelete,
    compact: true,
    hideOverlayDismiss: true
  }, "This may result in some people being unable to view this document."), /*#__PURE__*/React.createElement(ConfirmDialog, {
    position: !isMobile() && 'top',
    title: "Remove this document?",
    yes: "Remove Document",
    danger: true,
    state: view.confirmDocumentDelete,
    compact: true,
    hideOverlayDismiss: true
  }), /*#__PURE__*/React.createElement(Modal, {
    position: "top",
    isOpened: view.newVersionPrompt.showing,
    onRequestClose: view.newVersionPrompt.close
  }, /*#__PURE__*/React.createElement(Dialog, null, /*#__PURE__*/React.createElement(DialogTitle, null, "New Version"), /*#__PURE__*/React.createElement(Form, {
    onSubmit: view.newVersionPrompt.submit
  }, /*#__PURE__*/React.createElement(DialogContent, null, view.newVersionPrompt.text && /*#__PURE__*/React.createElement("p", {
    className: styles.newVersionText
  }, view.newVersionPrompt.text), /*#__PURE__*/React.createElement(Input, {
    label: "Message",
    placeholder: "Explain the purpose of creating this new version...",
    model: view.newVersionPrompt,
    field: "message"
  })), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButton, {
    onClick: view.newVersionPrompt.close
  }, "Cancel"), /*#__PURE__*/React.createElement(DialogButton, {
    primary: true,
    submit: true
  }, view.newVersionPrompt.button || 'Finish'))))));
};
var _Info = observer(function (_ref2) {
  var view = _ref2.view,
    showTags = _ref2.showTags;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.info
  }, /*#__PURE__*/React.createElement(InfoForm, {
    showArchived: true,
    view: view,
    showTags: showTags,
    buttonText: "Save"
  }));
});
DocumentInspectorView.defaultProps = {
  showTags: true
};
export default observer(DocumentInspectorView);
//# sourceMappingURL=DocumentInspectorView.js.map
